import React from 'react';
import AuthScreenShell from 'src/components/AuthScreenShell';
import { FINISH_REGISTRATION_ROUTE } from 'src/routes';
import SetNewPasswordForm from './SetNewPassword';

const AcceptInvitationView: React.FC = () => (
  <AuthScreenShell label="Admin">
    <div>
      <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
        Set your account's password
      </h2>
    </div>

    <div className="mt-8">
      <div className="mt-6">
        <SetNewPasswordForm submitTo={FINISH_REGISTRATION_ROUTE} />
      </div>
    </div>
  </AuthScreenShell>
);

export default AcceptInvitationView;
